import * as React from 'react';
import ClearAllView from '../../views/buy-tickets-clear-all.view';
import { removeAllEventFilters } from '../../redux-state/actions/buytickets.actions';
import { IBuyTicketsAppState } from '../../redux-state';
import { connect } from 'react-redux';
import { ICalendarAppBaseText } from '../../classes/buytickets-text';

interface IFilterExternalProps {
}

interface StateToProps {
    text: ICalendarAppBaseText;
}

interface DispatchToProps {
    removeAllFilters: () => void;
}

export type ClearAllProps = IFilterExternalProps & StateToProps & DispatchToProps;

export class ClearAllBase extends React.Component<ClearAllProps, null> {
    render() {
        return <ClearAllView {...this.props} />;
    }
}

function mapStateToProps(state: IBuyTicketsAppState, ownProps: IFilterExternalProps): StateToProps {
    return {
        text: state.calendarText
    }
}

function mapDispatchToProps(dispatch): DispatchToProps {
    return {
        removeAllFilters: () => {
            dispatch(removeAllEventFilters());
        }
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(ClearAllBase);